/**
 * @generated SignedSource<<ef50576142d42d697088791be119e55e>>
 * @relayHash 4672ed93b12d254ea2e647162e179920
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 4672ed93b12d254ea2e647162e179920

import { ConcreteRequest } from 'relay-runtime';
export type Country = "CH" | "DE";
export type CallPatientInput = {
  country: Country;
  isRecordingAllowed: boolean;
  patientId: string;
  phoneNumber: string;
  progressNoteId: number;
};
export type useCallPatientMutation$variables = {
  input: CallPatientInput;
};
export type useCallPatientMutation$data = {
  readonly callPatient: {
    readonly callPatientOutput: {
      readonly conversationId: string;
    } | null;
    readonly errors: ReadonlyArray<{
      readonly __typename: "AgentNotAuthenticated";
    } | {
      readonly __typename: "CallAlreadyInProgress";
    } | {
      readonly __typename: "InvalidPatientPhoneNumber";
    } | {
      // This will never be '%other', but we need some
      // value in case none of the concrete values match.
      readonly __typename: "%other";
    }> | null;
  };
};
export type useCallPatientMutation = {
  response: useCallPatientMutation$data;
  variables: useCallPatientMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "concreteType": "CallPatientOutput",
  "kind": "LinkedField",
  "name": "callPatientOutput",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "conversationId",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v3 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "__typename",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useCallPatientMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "CallPatientPayload",
        "kind": "LinkedField",
        "name": "callPatient",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              {
                "kind": "InlineFragment",
                "selections": (v3/*:: as any*/),
                "type": "AgentNotAuthenticated",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": (v3/*:: as any*/),
                "type": "InvalidPatientPhoneNumber",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": (v3/*:: as any*/),
                "type": "CallAlreadyInProgress",
                "abstractKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "useCallPatientMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "CallPatientPayload",
        "kind": "LinkedField",
        "name": "callPatient",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": (v3/*:: as any*/),
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "4672ed93b12d254ea2e647162e179920",
    "metadata": {},
    "name": "useCallPatientMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "28601afd30d7912014c613beacbf211c";

export default node;
